import script from "./ButtonAccentSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonAccentSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonAccentSecondary.vue?vue&type=style&index=0&id=b35cf6f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b35cf6f2"]])

export default __exports__